import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission, SocketEvents } from 'utils';
import {
  Table,
  Pagination,
  Tooltip,
  Input,
  DatePicker,
  Select,
  Modal,
  User,
  Button,
} from 'components';
import { CleanIcon, CallIcon, CopyIcon } from 'assets/icons';
import { CallService } from 'services';
import moment from 'moment';
import * as Jetemit from 'jetemit';

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  search: '',
};

class Calls extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: ['Cliente', 'Nro de ID', 'Motivo', 'Fecha', 'Hora', 'Teléfono', 'Estatus'],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    item: null,
    visible: false,
    plan_user: undefined,
    is_internal: false,
    unsubscriber: () => {},
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Llamadas Teléfonicas',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.setState({
      unsubscriber: Jetemit.on(SocketEvents.CALLS.NEW_CALL, (data: any) => {
        if (Number(data.lawyer_id) === Number(this.props.user?.id)) {
          this.load(true);
        }
      }),
    });

    this.load();
  }

  componentWillUnmount() {
    this.state.unsubscriber();
  }

  load = async (withoutLoading: boolean = false) => {
    try {
      const res: any = await CallService.get({
        withoutLoading,
        page: this.state.page,
        ...this.state.form,
        user_id: this.props.user?.id,
      });
      this.setState({
        data: res.rows,
        last_page: res.count,
        plan_user: res.plan_user,
        is_internal: res.is_internal,
      });
    } catch (error) {}
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  onClose = (reload: boolean = false) => {
    this.setState(
      {
        visible: false,
      },
      () => {
        if (reload) {
          this.load(true);
        }
      },
    );
  };

  onChangeStatus = async (item: any, status: number) => {
    let text = '';

    switch (status) {
      case Constants.CALL_STATUS.RESOLVED:
        text = 'Resuelto';
        break;

      case Constants.CALL_STATUS.NO_RESOLVED:
        text = 'Sin resolver';
        break;

      case Constants.CALL_STATUS.REVIEW:
        text = 'En revisión';
        break;

      case Constants.CALL_STATUS.IN_PROCESS:
        text = 'En proceso';
        break;

      case Constants.CALL_STATUS.PENDING:
        text = 'Pendiente';
        break;
    }

    Globals.confirm('¿Desea cambiar el estado de la llamada a ' + text + '?', async () => {
      const { id } = item;
      const { user } = this.props;

      try {
        await CallService.update({
          id,
          status,
          lawyer_id: user?.id,
          resolved_type: Constants.LAWYER_INTERNAL.YES,
        });
        this.load();

        if (status == Constants.CALL_STATUS.REVIEW) {
          this.props.history.replace('/lawyer/chat');
          setTimeout(() => {
            Jetemit.emit('open-create-chat');
          }, 500);
        }
      } catch (error) {}
    });
  };
  clipboard = (e: any, text: string) => {
    e.preventDefault();
    navigator.clipboard.writeText(text);
  };

  render() {
    const plan_user: any = this.state.plan_user;
    const is_internal: boolean = this.state.is_internal;

    return (
      <div id='lawyer-calls'>
        {plan_user === null && !is_internal ? (
          <div className='container-no-membership'>
            <p>Para ver este contenido debe tener una membresía activa</p>
          </div>
        ) : (
          <>
            <div className='row row-filter'>
              <div className='col-md-12'>
                <div className='row'>
                  <div className='col-md-4'>
                    <Input
                      value={this.state.form.search}
                      name='search'
                      label='Buscar'
                      placeholder='Buscar'
                      className='input-table'
                      onSubmit={() => this.load()}
                      onChange={(e: any) => {
                        clearTimeout(this.timer);
                        this.timer = setTimeout(() => {
                          this.load(true);
                        }, 1000);
                        this.change(e);
                      }}
                    />
                  </div>
                  <div className='col-md-1'>
                    {this.state.form != INITIAL_STATE && (
                      <button className='btn btn-clean' onClick={() => this.reset()}>
                        <img src={CleanIcon} />
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <Table title='' data={this.state.data.length} header={this.state.header}>
              {this.state.data.map((i: any, index: number) => {
                const [start, end] = i.hour.split(',');
                const toFormatStart = moment(start, 'HH:mm').format('hh:mm A');
                const toFormatEnd = moment(end, 'HH:mm').format('hh:mm A');
                const phoneNumberLabel = i?.user
                  ? `${i.user.phonecode?.name ?? ''}-${i.user.phone ?? ''}`
                  : 'Cliente no disponible';
                const phoneNumber = i?.user
                  ? `${i.user.phonecode?.name ?? ''}${i.user.phone ?? ''}`
                  : '';
                return (
                  <tr key={index}>
                    <td>
                      <User image={i.user?.photo} name={i?.user?.full_name} />
                    </td>
                    <td className='code'>{i?.number}</td>
                    <td className='description'>
                      {i?.description ? (
                        <Tooltip title={i.description}>
                          <span className='description-text'>{i.description}</span>
                        </Tooltip>
                      ) : (
                        '-'
                      )}
                    </td>
                    <td>{moment(i?.day).format('DD-MM-YYYY')}</td>
                    <td>
                      {toFormatStart} a {toFormatEnd}
                    </td>
                    <td>
                      {phoneNumberLabel}{' '}
                      <a href='#' onClick={(e: any) => this.clipboard(e, phoneNumber)}>
                        <img width={20} src={CopyIcon} />
                      </a>
                    </td>
                    <td>{i?.status_text}</td>
                    {(i?.status === Constants.CALL_STATUS.PENDING ||
                      i?.status == Constants.CALL_STATUS.IN_PROCESS ||
                      i?.status == Constants.CALL_STATUS.REVIEW) &&
                    moment(i?.day).isBefore(moment().toISOString()) ? (
                      <td>
                        <div className='btn-container'>
                          <button
                            className='btn btn-resolved'
                            onClick={() => this.onChangeStatus(i, Constants.CALL_STATUS.RESOLVED)}
                          >
                            Resuelto
                          </button>
                          {i?.call_id === null && (
                            <button
                              className='btn btn-unresolved'
                              onClick={() =>
                                this.onChangeStatus(i, Constants.CALL_STATUS.NO_RESOLVED)
                              }
                            >
                              Sin resolver
                            </button>
                          )}
                          {i?.call_id === null && i?.status != Constants.CALL_STATUS.REVIEW && (
                            <button
                              className='btn btn-yellow'
                              onClick={() => this.onChangeStatus(i, Constants.CALL_STATUS.REVIEW)}
                            >
                              En revisión
                            </button>
                          )}
                        </div>
                      </td>
                    ) : (
                      <td></td>
                    )}
                  </tr>
                );
              })}
            </Table>

            <Pagination
              pages={this.state.last_page}
              active={this.state.page}
              onChange={async (page: number) => {
                await this.setState({
                  page: page,
                });
                this.load();
              }}
            />
          </>
        )}
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(Calls);
